const fonts = {
  body: "'Roboto', sans-serif",
  heading: "'Montserrat', sans-serif",
  mono: "'Roboto', sans-serif",
};

export default fonts;
